import { render, staticRenderFns } from "./Commitment.vue?vue&type=template&id=248f9e85&scoped=true"
import script from "./Commitment.vue?vue&type=script&lang=js"
export * from "./Commitment.vue?vue&type=script&lang=js"
import style0 from "./Commitment.vue?vue&type=style&index=0&id=248f9e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f9e85",
  null
  
)

export default component.exports